export default "__VITE_ASSET__p7Zq55Yy__"